import { render, staticRenderFns } from "./AssignTeacher.vue?vue&type=template&id=482292dc"
import script from "./AssignTeacher.vue?vue&type=script&lang=js"
export * from "./AssignTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports